import React, { Component } from 'react'
import { graphql, compose, gql } from 'react-apollo'
import { translate } from 'react-i18next'
import { NotificationManager } from 'react-notifications'
import PropTypes from 'prop-types'
import { client } from '../../index'

import Slider from 'react-slick'

import getByPath from 'lodash/get'
import isFunction from 'lodash/isFunction'

import config from './../../config'
import { isCurrentLanguageRTL } from '../../i18n'; 


import ImgBankPhotoSelectionModal from '../ImgBankPhotoSelection/ImgBankPhotoSelectionModal'

import DELETE_FILE_QUERY from './../../graphql/DeleteFile.graphql'

class PhotoSlider extends Component {
  static propTypes = {
    photos: PropTypes.array.isRequired,
    selected: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    onPhotosAdd: PropTypes.func.isRequired,
    onDefaultPhotoSelect: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      showLoader: false,
      _selected: []
    }
  }

  async onImageUpload(e) {
    console.log(e)

    if (e.length > 0) {
      this.setState({
        showLoader: true
      })

      let res
      let blob
      let photoRes
      let photo

      let photoForUpload = e[0]

      let reader = new FileReader()
      reader.onload = async function(e) {
        photoForUpload.src = e.target.result

        photo = new File([photoForUpload], photoForUpload.name)
        const body = new FormData()

        body.append('data', photo)

        try {
          photoRes = await fetch(config.fileAPI, {
            method: 'POST',
            body
          })
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)

          this.setState({
            showLoader: false
          })
        }

        try {
          photo = await photoRes.json()
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)

          this.setState({
            showLoader: false
          })
        }

        const selected = [...this.props.selected]

        selected.unshift(photo)
        selected.pop()

        this.props.onSelect(selected)

        this._selectDefault(selected)

        this.setState({
          showLoader: false
        })
      }.bind(this)

      reader.readAsDataURL(e[0])
    }
  }

  async onPhotoSelect() {
    const { photos, onSelect, onPhotosAdd } = this.props
    const index = getByPath(this.slider, 'innerSlider.state.currentSlide', null)

    if (photos[index]) {
      let res
      let blob
      let photoRes
      let photo

      if (!photos[index].id) {
        this.setState({
          showLoader: true
        })

        try {
          const url = photos[index].getUrl({ maxWidth: 1920, maxHeight: 1080 })
          res = await client.query({
            query: uploadImage,
            variables: {
              path: url
            }
          })
          photo = {id: res.data.uploadImage.id, url: res.data.uploadImage.url}
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)
          this.setState({
            showLoader: false
          })
        }

        /*
        try {
          blob = await res.blob()
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)

          this.setState({
            showLoader: false
          })
        }

        try {
          const photo = new File([blob], 'photo.png')
          const body = new FormData()

          body.append('data', photo)

          photoRes = await fetch(config.fileAPI, {
            method: 'POST',
            body
          })
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)

          this.setState({
            showLoader: false
          })
        }

        try {
          photo = await photoRes.json()
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)

          this.setState({
            showLoader: false
          })
        }
        */
      } else {
        photo = photos[index]
      }

      const selected = [...this.props.selected]

      selected.unshift(photo)
      selected.pop()

      onSelect(selected)
      onPhotosAdd(photos.filter((_, i) => i !== index))

      this._selectDefault(selected)

      const newSelected = photos[index]

      newSelected._id = photo.id

      this.setState({
        _selected: [...this.state._selected, newSelected],
        showLoader: false
      })
    }
  }

  _selectDefault(selected) {
    const selectedPhoto = selected.find(photo => photo && photo.isDefault)

    if (!selectedPhoto && selected[0]) {
      selected[0].isDefault = true

      if (isFunction(this.props.onDefaultPhotoSelect)) {
        this.props.onDefaultPhotoSelect(0)
      }
    }
  }

  onDefaultPhotoSelect(index) {
    const { selected, onDefaultPhotoSelect } = this.props

    if (selected[index] && isFunction(onDefaultPhotoSelect)) {
      onDefaultPhotoSelect(index)
    }
  }

  async onRemoveSelected(index, event) {
    event.stopPropagation()

    const selected = [...this.props.selected]
    const photo = selected[index]

    let removedPhoto = this.state._selected.find(el => el._id === photo.id)
    if (removedPhoto) {
      this.props.onPhotosAdd([...this.props.photos, removedPhoto])
    }

    /*
    try {
      await this.props.deleteFile({
        variables: {
          id: photo.id
        }
      })
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
    */

    selected.splice(index, 1)
    selected.push(null)

    this.props.onSelect(selected)

    this._selectDefault(selected)
  }

  renderPhotos() {
    const { photos } = this.props

    if (photos.length) {
      return photos.map((photo, i) => (
        <div key={i}>
          <div className="image-container">
            <img src={photo.url || photo.getUrl({ maxWidth: photo.width })} alt="" />
          </div>
        </div>
      ))
    } else {
      return (
        <div onClick={() => this.fileInput.click()} style={{ cursor: 'pointer' }}>
          <div className="icon-container">
            <i className="icon-plus" />
          </div>
        </div>
      )
    }
  }

  closeModal = index => {
    const imgModal = {}
    imgModal['imgModal'] = false
    this.setState(imgModal, () => {})
  }

  render() {
    const { label, photos, selected, t } = this.props
    const { showLoader, imgModal } = this.state

    const selectedPhotosLength = selected.filter(photo => photo).length

    return (
      <div className="photo-slider">
        <h2 className="photo-slider__label">{label}</h2>
        <div style={{ position: 'relative' }}>
          <div className={`loader__container${showLoader ? '' : '--hidden'}`}>
            <img src="/img/rolling.svg" style={{ width: '100px', height: '100px' }} className="loader__image" alt="" />
          </div>
          <Slider
            ref={slider => {
              this.slider = slider
            }}
            dots={false}
            arrows={false}
            infinite={false}
          >
            {this.renderPhotos()}
          </Slider>
        </div>
        <div className="photo-slider__controls">
          <div className="photo-slider__more-details">
            { !isCurrentLanguageRTL() && 
              <i className="icon-arrow-previous" onClick={() => this.slider.slickPrev()} />
            }
            { isCurrentLanguageRTL() && 
              <i className="icon-arrow-next" onClick={() => this.slider.slickPrev()} />
            }
            <span>
              {t('more_details')} ({photos.length})
            </span>
            { !isCurrentLanguageRTL() && 
              <i className="icon-arrow-next" onClick={() => this.slider.slickNext()} />
            }
            { isCurrentLanguageRTL() && 
              <i className="icon-arrow-previous" onClick={() => this.slider.slickNext()} />
            }
          </div>
          <div className="photo-slider__select-picture" onClick={() => this.onPhotoSelect()}>
            <span>
              {t('select_picture')} ({selectedPhotosLength}/3)
            </span>
            <i className="icon-plus" />
          </div>
          <div
            className="photo-slider__upload"
            onClick={e => {
              let imgModal = {}
              imgModal['imgModal'] = true
              this.setState(imgModal, () => {})
            }}
          >
            <label htmlFor="manually-upload" className="photo-slider__upload-label">
              <span>{t('upload_picture_manually')}</span>
            </label>
            <ImgBankPhotoSelectionModal
              id="manually-upload"
              isOpen={this.state['imgModal']}
              onClose={this.closeModal}
              onFileChange={e => this.onImageUpload(e)}
              t={t}
            />
          </div>
        </div>
        <div className="photo-slider__selected-photos">
          {selected.map((photo, i) => (
            <div className="photo_slider__selected-photo selected-photo" key={i}>
              <div
                className={`selected-photo__image ${photo && photo.isDefault ? 'selected-photo__image--default' : ''}`}
                style={{ backgroundImage: photo ? `url(${photo.url})` : '', cursor: photo ? 'pointer' : '' }}
                onClick={() => this.onDefaultPhotoSelect(i)}
              />
              {!!photo && (
                <div className="selected-photo__remove-icon-container">
                  <i className="selected-photo__remove-icon icon-cancel" onClick={e => this.onRemoveSelected(i, e)} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    )
  }
}

const uploadImage = gql`
query uploadImage($path: String!) {
  uploadImage(path: $path) {
    id
    url
  }
}
`


const enhance = compose(
  translate('photo_slider'),
  graphql(DELETE_FILE_QUERY, {
    name: 'deleteFile'
  })
)
export default enhance(PhotoSlider)



// WEBPACK FOOTER //
// src/components/PhotoSlider/index.js